import { Button } from '@pmi/dsm-react';
import { useEffect, useState } from 'react';
import Overlay from '../../../shared/components/Overlay';
import styles from '../logs.module.scss';
import ErrorLogsTable from './ErrorLogsTable';
import LogSearchField from '../LogSearchField';
import { LogSearchApiRequest } from '../apiSlice';
import { SearchItemMap, SearchLogColumn } from '../LogSearchField/models';
import useGetLogs from '../../../shared/hooks/useGetLogs';

export default function ErrorsLog() {
  const [initialRequest, setInitialRequest] = useState(true);
  const [search, setSearch] = useState<LogSearchApiRequest>({
    logType: 'Error',
  });
  const [logList, setLogList] = useState([]);
  const { storedData, hasMore, handleLoadMore, isLoading } = useGetLogs(
    search,
    initialRequest,
  );
  const columns: SearchLogColumn[] = [
    { label: 'Error', value: 'action' },
    { label: 'Agreement ID', value: 'search' },
    { label: 'Performed By', value: 'user' },
    { label: 'Date/Time', value: 'startDate' },
  ];
  const mapColumns: SearchItemMap[] = [
    { column: 'action', with: 'action' },
    { column: 'user', with: 'user' },
    { column: 'search', with: 'search' },
    { column: 'startDate', with: 'startDate' },
  ];
  const onSearch = (searchData: { [key: string]: string } | null) => {
    if (searchData) {
      const clone: LogSearchApiRequest = { ...searchData };
      clone.logType = 'Error';
      if (clone?.search?.length > 0) {
        clone.searchField = 'DealId';
      }
      setInitialRequest(true);
      setSearch(clone);
      return;
    }
    setSearch(null);
  };
  useEffect(() => {
    setLogList(storedData?.filter((log) => log.logType === 'Error'));
  }, [search, isLoading, storedData]);
  return (
    <>
      <LogSearchField
        onSearch={onSearch}
        columns={columns}
        mapColumns={mapColumns}
      />
      <h5 className=" fw-normal fs-4 my-3">
        <strong className="fw-bold">
          <span>Error Log</span>
        </strong>
      </h5>
      <div className={styles['card-container']}>
        {!isLoading && logList && logList?.length === 0 && (
          <p className={`${styles['no-log-msg']}`}>No error logs available</p>
        )}

        {!isLoading && logList && logList?.length > 0 && (
          <ErrorLogsTable logs={logList} />
        )}
      </div>
      {!isLoading && hasMore && logList && logList?.length > 0 && (
        <div className="text-center pt-3">
          <Button
            variant="primary"
            onClick={() => {
              setInitialRequest(false);
              handleLoadMore();
            }}
            titleText="Load More"
          />
        </div>
      )}
      <Overlay
        variant="PMIOverlay"
        global
        animated
        fade
        iconColor="brand-dark"
        overlayColor="black"
        overlayOpacity={1}
        show={isLoading}
      />
    </>
  );
}
